/* eslint-disable import/prefer-default-export */
import { ohsListParamKeys, OhsListParams } from '../OhsRegisterModels';

// takes params and returns usable object
// handle possible casing issues in url params
export const normalizeSearchParams = (searchParams: URLSearchParams): Partial<OhsListParams> => {
  const keyMap: Record<string, keyof OhsListParams> = ohsListParamKeys.reduce((acc, key) => {
    acc[key.toLowerCase()] = key;
    return acc;
  }, {} as Record<string, keyof OhsListParams>);

  const normalizedParams: Partial<OhsListParams> = {};

  if (searchParams.size) {
    Array.from(searchParams.entries()).forEach(([key, value]) => {
      const match = keyMap[key.toLowerCase()];
      if (match) {
        normalizedParams[match] = value as any;
      }
    });
  }

  return normalizedParams;
};
